// @ts-strict-ignore
export class PrintLabelingArticleInfo {
  public articleNo: string;
  public articleId: number;
  public articleVersions: number[];
  public articleUsageIds: string[];

  public children: PrintLabelingArticleInfo[];
  public label: string;
  public labelForSubNodes: string = '';
  public isSelected: boolean = false;
  public hasCutmarkAbility: boolean = false;
  public addCutMark: boolean = false;
}
